import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import commonReducer from '../features/common/commonSlice';
import toastReducer from '../features/toast/toastSlice';
import skillTrainerReducer from '../features/skillTrainer/skillTrainerSlice';
import skillInfoReducer from '../features/skillTrainer/skillInfoSlice';
import skillPracReducer from '../features/skillTrainer/skillPracSlice';
import skillSaveReducer from '../features/skillTrainer/skillSaveSlice';
import skillLoadReducer from '../features/skillTrainer/skillLoadSlice';
import skillShareReducer from '../features/skillTrainer/skillShareSlice';
import weaveTrainerReducer from '../features/weaveTrainer/weaveTrainerSlice';
import weaveInfoReducer from '../features/weaveTrainer/weaveInfoSlice';
import weavePracReducer from '../features/weaveTrainer/weavePracSlice';
import weaveSaveReducer from '../features/weaveTrainer/weaveSaveSlice';
import weaveLoadReducer from '../features/weaveTrainer/weaveLoadSlice';
import weaveShareReducer from '../features/weaveTrainer/weaveShareSlice';
import equipmentReducer from '../features/equipment/equipmentSlice';
import editEquipmentReducer from '../features/equipment/editEquipmentSlice';
import equipmentTrainerReducer from '../features/equipmentTrainer/equipmentTrainerSlice';
import mobsReducer from '../features/mobs/mobsSlice';

export const store = configureStore({
  reducer: {
    common: commonReducer,
    toast: toastReducer,
    skillTrainer: skillTrainerReducer,
    skillInfo: skillInfoReducer,
    skillPrac: skillPracReducer,
    skillSave: skillSaveReducer,
    skillLoad: skillLoadReducer,
    skillShare: skillShareReducer,
    weaveTrainer: weaveTrainerReducer,
    weaveInfo: weaveInfoReducer,
    weavePrac: weavePracReducer,
    weaveSave: weaveSaveReducer,
    weaveLoad: weaveLoadReducer,
    weaveShare: weaveShareReducer,
    equipment: equipmentReducer,
    editEquipment: editEquipmentReducer,
    equipmentTrainer: equipmentTrainerReducer,
    mobs: mobsReducer
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
